import * as animationData from '../../assets/animations/waiting-animation.json';
import DoctorCard from '../../components/DoctorCard';
import { formatPhone } from '../../utils/utils';

import { Card, DateUtils, Flex, Separator, Text, Icon, Link } from '@amigoapp/doca-react';
import Lottie from 'react-lottie';

const WaitingRoom = ({ user, company, attendance, createdAt }) => (
	<Flex align="center" className="doca-text--center" direction="col" flex={1} gap={3} justify="between">
		<Card className="doca-p-4 telemedicine-waiting-room-card">
			<DoctorCard
				avatar={user.file?.thumb_url}
				councilName={user.council_name}
				councilNumber={user.council_number}
				name={user.name}
				specialty={user.specialty}
				title={user.title}
			/>
			<Separator />
			<Flex align="center" className="doca-mb-4" gap={2}>
				<Icon color="gray" name="calendar-clock" type="light" />
				<Text size="extra-small" variant="gray" weight="light">
					{DateUtils.format(attendance?.start_date ? attendance.start_date : createdAt, { format: 'DD/MM/YYYY [às] HH:mm' })}
				</Text>
			</Flex>
			<Flex align="center" className="doca-mb-4" gap={2}>
				<Icon color="gray" name="building" type="light" />
				<Text size="extra-small" variant="gray" weight="light">
					{company.name}
				</Text>
			</Flex>
			{(company.contact_phone || company.contact_phone_2) && (
				<Flex align="center" gap={2}>
					<Icon color="gray" name="phone" type="light" />
					<Link className="doca-text--extra-small doca-text--light" href={`tel:${company.contact_phone || company.contact_phone_2}`}>
						{formatPhone(company.contact_phone || company.contact_phone_2)}
					</Link>
				</Flex>
			)}
		</Card>
		<Flex className="doca-p-6" direction="col" flex={1} justify="center">
			<Lottie height="auto" id="ok" options={{ loop: true, autoplay: true, animationData: animationData.default }} width="80%" />
			<Text as="h1" className="doca-mb-2" size="extra-large" variant="gray" weight="bold">Por favor, aguarde.</Text>
			<Text size="small" variant="gray" weight="light">Sua consulta irá começar em instantes</Text>
		</Flex>
		<Text className="doca-m-4" size="extra-small" variant="gray" weight="light">
			Dicas para um ótimo teleatendimento: Use fones de ouvido para eliminar o eco.
		</Text>
	</Flex>
);

export default WaitingRoom;
